// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget--vehicle-status-history{display:flex;flex-flow:column;height:100%}.widget--vehicle-status-history .title{margin-bottom:10px}.widget--vehicle-status-history .empty-message{font-size:21px;font-style:italic;padding:8px;color:#787f87}.widget--vehicle-status-history .vehicle-status-history-list{flex-grow:1;overflow:auto}", ""]);
// Exports
module.exports = exports;
